module.exports = __webpack_public_path__ + "static/img/5.02459da3.png";